import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-terms-service',
    templateUrl: './terms-service.component.html',
    styleUrls: ['./terms-service.component.css'],
    providers: [NgxSpinnerService]
})

export class TermsServiceComponent implements OnInit {
    privacyPolicyUrl =  environment.privacyPolicy;
    constructor(
        private translate: TranslateService,
        public functionsService: FunctionsService
    ) { 
        this.translate.setDefaultLang('en');
        this.functionsService.setTitle('register.terms_of_service');
    }

    async ngOnInit() {
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguage(localStorage.getItem('language'));
        }else{ //If the language is not specified, use default one.
            this.functionsService.useLanguage('en');
        }
    }
}